import { findModels } from "../../../infrastructure/repository/benefit-models-repository";
import adaptBenefitPlans from "../../../infrastructure/adapters/adaptBenefitPlans";
import BenefitPlan from "../../../app/domain/BenefitPlan";

export default async function fetchBenefitPlans({
  callback,
}: {
  callback(e: BenefitPlan[]): void;
}): Promise<void> {
  const { data: benefitPlans } = await findModels();
  callback(adaptBenefitPlans({ benefitPlans }));
}
